export default __webpack_public_path__ + "images/cdcb58eb-warning-circle-svgrepo-com.svg";